// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../Config.bs.js";
import * as IncentivesRepo from "./IncentivesRepo.bs.js";
import * as DummyIncentivesRepo from "./DummyIncentivesRepo.bs.js";

function getIncentivesRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchIncentives: DummyIncentivesRepo.IncentivesRepo.fetchIncentives,
            fetchCampaignOrders: DummyIncentivesRepo.IncentivesRepo.fetchCampaignOrders
          };
  } else {
    return IncentivesRepo.IncentivesRepo;
  }
}

export {
  getIncentivesRepo ,
  
}
/* Config Not a pure module */
